import { useEffect } from 'react';
import { getWindow } from '@fluentui/react';
import { logger } from '@src/logger';
import { IClarityFunctionNames } from '@shared/components';
export const useMsClarityIdentify = ({ correlationId, spzaId })=>{
    useEffect(()=>{
        if (correlationId && spzaId && getWindow()) {
            try {
                var _getWindow;
                (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.clarity(IClarityFunctionNames.IDENTIFY, spzaId, correlationId);
            } catch (error) {
                logger.error('clarity identify failed', {
                    action: 'useMsClarityIdentify',
                    error
                });
            }
        }
    }, [
        spzaId,
        correlationId
    ]);
};
export const useMsClarityTracking = ({ allowTracking })=>{
    useEffect(()=>{
        const currentWindow = getWindow();
        if (allowTracking && (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.clarity)) {
            try {
                currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.clarity(IClarityFunctionNames.CONSENT_V2, {
                    ad_Storage: 'granted',
                    analytics_Storage: 'granted'
                });
            } catch (error) {
                logger.error('clarity consent failed', {
                    action: 'useMsClarityTracking',
                    error
                });
            }
        }
    }, [
        allowTracking
    ]);
};
